import { Table, TableBody, TableHead, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import StyledTableCell from "../../Tables/StyledTableCell";
import StyledTableRow from "../../Tables/StyledTableRow";
import TableActions from "./TableActions";
import Note from "../Note";
import { PRE_PROPOSAL_STATUS } from "../../../Constants";

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
  },
}));

export default function ResearchesTable(props) {
  const classes = useStyles();
  const {
    researchers,
    tableType,
    updateApplicantStatus,
    createPDF,
    updateResearcherNote,
  } = props;
  const tableHeaders = [
    { label: "Name", width: "15%" },
    { label: "Department", width: "15%" },
    { label: "Primary Email", width: "30%" },
    { label: "Applicantion title & no.", width: "30%" },
    { label: "Stage", width: "10%" },
    { label: "Actions", width: "20%" },
    { label: "Notes", width: "10%" },
  ];
  return (
    <Table className={classes.table}>
      <TableHead>
        <StyledTableRow>
          {tableHeaders.map((header) => (
            <StyledTableCell key={header.label} style={{ width: header.width }}>
              {header.label}
            </StyledTableCell>
          ))}
        </StyledTableRow>
      </TableHead>
      <TableBody>
        {researchers.map((research) => (
          <StyledTableRow key={`${research.applicantId} ${tableType}`}>
            <StyledTableCell>
              {research.applicantName} {research.isLeader && "(Leader)"}
            </StyledTableCell>
            <StyledTableCell>{research.applicantDepartment}</StyledTableCell>
            <StyledTableCell>{research.applicantEmail}</StyledTableCell>
            <StyledTableCell>
              <Typography>{research.proposalNumber}</Typography>
              <Typography>{research.proposalTitle}</Typography>
            </StyledTableCell>
            <StyledTableCell>
              {research.proposalStatusCode === PRE_PROPOSAL_STATUS
                ? "Pre Proposal"
                : "Proposal"}
            </StyledTableCell>
            <StyledTableCell>
              <TableActions
                createPDF={() =>
                  createPDF(research.proposalId, research.proposalNumber)
                }
                actionsType={tableType}
                updateApplicantStatus={updateApplicantStatus}
                applicantId={research.applicantId}
                proposalId={research.proposalId}
              />
            </StyledTableCell>
            <StyledTableCell>
              <Note
                text={research.noteFromRA || ""}
                onSave={(note) =>
                  updateResearcherNote(research.applicantId, note)
                }
              />
            </StyledTableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </Table>
  );
}
